import Component from '../Component';

class LayoutSelect extends Component {
  constructor(options) {
    super(options);
    this.gridView = this.root.querySelector('.grid_view_btn');
    this.listView = this.root.querySelector('.list_view_btn');
  }

  attachEventListeners() {
    this.listView.addEventListener('click', () => {
      if (!this.root.classList.contains('list_view')) {
        this.root.classList.add('list_view');
        this.gridView.classList.remove('active');
        this.listView.classList.add('active');
      }
    });

    this.gridView.addEventListener('click', () => {
      if (this.root.classList.contains('list_view')) {
        this.root.classList.remove('list_view');
        this.listView.classList.remove('active');
        this.gridView.classList.add('active');
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default LayoutSelect;
